import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Swal from 'sweetalert2';
import { MenuItem, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { createSafalEventTypeTask, updateSafalEventTypeTask } from '../../../services/Service';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  maxHeight: '95vh',
  overflow: 'auto',
  '@media (max-width: 640px)': {
    width: '95vw',
  },
};

const initFieldValue = {
  type: '', // required
  planningPhase: '', // optional
  timeline: '', // optional
  notes: '', // optional
  description: '', // optional
  status: '', // optional Active / Inactive
};

export default function AddSafalEventTypeModal({ open, onClose, data, isDisplay, eventType }) {
  const [fieldValue, setFieldValue] = React.useState({ ...initFieldValue });
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const handleClose = () => {
    setFieldValue({ ...initFieldValue });
    setIsDisableAll(false);
    onClose();
  };

  const onSubmit = async () => {
    setIsDisableAll(true);

    try {
      const res = await createSafalEventTypeTask(fieldValue);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdateSubmit = async () => {
    setIsDisableAll(true);
    try {
      const res = await updateSafalEventTypeTask({ ...fieldValue, _id: data._id });
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  React.useEffect(() => {
    if (open === true && data !== null) {
      setFieldValue({
        type: data?.type?._id ?? '',
        description: data?.description ?? '',
        status: data?.status ?? '',
        planningPhase: data?.planningPhase ?? '',
        notes: data?.notes ?? '',
        timeline: data?.timeline ?? '',
      });
      setIsDisableAll(isDisplay);
    }
  }, [open, data, isDisplay]);

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ marginBottom: '16px', fontSize: '30px', fontWeight: 700, color: '#19c25f' }}
        >
          {data === null ? 'Add Event Type To Task' : isDisplay ? 'Event Type To Task' : 'Update Event Type To Task'}
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {/* type */}
          <TextField
            value={fieldValue.type}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, type: e.target.value }))}
            required
            select
            label="Type"
            size="small"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          >
            {eventType.map((e) => (
              <MenuItem key={e._id} value={e._id}>
                {e.name}
              </MenuItem>
            ))}
          </TextField>
          {/* description */}
          <TextField
            value={fieldValue.description}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, description: e.target.value }))}
            label="Task Description"
            size="small"
            type="text"
            required
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          />
          {/* planningPhase */}
          <TextField
            value={fieldValue.planningPhase}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, planningPhase: e.target.value }))}
            required
            label="Planning Phase"
            size="small"
            type="text"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          />
          {/* timeline */}
          <TextField
            value={fieldValue.timeline}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, timeline: e.target.value }))}
            required
            label="Timeline"
            size="small"
            type="text"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          />
          {/* notes */}
          <TextField
            value={fieldValue.notes}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, notes: e.target.value }))}
            label="Notes"
            size="small"
            type="text"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          />
          {/* status */}
          <TextField
            value={fieldValue.status}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, status: e.target.value }))}
            required
            select
            label="Status"
            size="small"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </TextField>
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'end' }}>
          <Button
            disabled={isDisplay ? false : isDisableAll}
            onClick={handleClose}
            sx={{ backgroundColor: '#19c25f', textTransform: 'capitalize' }}
            variant="contained"
          >
            Cancel
          </Button>
          {!isDisplay && (
            <Button
              disabled={isDisableAll}
              onClick={data === null ? onSubmit : onUpdateSubmit}
              sx={{ backgroundColor: '#19c25f', textTransform: 'capitalize' }}
              variant="contained"
            >
              {data === null ? 'Create' : 'Update'}
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
}
